import React, { useState, useEffect } from "react";
import styles from "./App.module.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// pages & components
import LandingPage from "./pages/landingpage/LandingPage";

// components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function App() {
  const [isNavbarHidden, setIsNavbarHidden] = useState(false);

  const handleScroll = () => {
    const currentScrollTop = window.scrollY;
    const isScrolledUp = currentScrollTop > 10; // Adjusted scroll position to make it reappear much earlier (e.g., 10 pixels)
    setIsNavbarHidden(!isScrolledUp);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.App}>
      <div className="content">
        <Router>
          <Navbar isNavbarHidden={isNavbarHidden} />
          <Routes>
            <Route path="/" element={<LandingPage />} />
          </Routes>
          <Footer />
        </Router>
      </div>
    </div>
  );
}

export default App;
